import createLucideIcon from '../createLucideIcon';

const MoreVertical = createLucideIcon('MoreVertical', [
  ['circle', { cx: '12', cy: '12', r: '1', key: '41hilf' }],
  ['circle', { cx: '12', cy: '5', r: '1', key: 'gxeob9' }],
  ['circle', { cx: '12', cy: '19', r: '1', key: 'lyex9k' }],
]);

export default MoreVertical;
